export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, введите название ', trigger: 'change' },
    ],
    branch_name: [
        { required: true, message: 'Пожалуйста, введите название ', trigger: 'change' },
    ],
    mfo: [
        { required: true, message: 'Пожалуйста, введите название ', trigger: 'change' },
    ],
    number: [
        { required: true, message: 'Пожалуйста, введите название ', trigger: 'change' },
    ],
    currency_id: [
        { required: true, message: 'Пожалуйста, введите название ', trigger: 'change' },
    ],
    active: [
        { required: true, message: 'Пожалуйста, введите название ', trigger: 'change' },
    ]
};
